import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import rootReducer from './reducers';
import { authMidWare } from './middleware';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import createBrowserHistory from 'history/createBrowserHistory';

export const history = createBrowserHistory();
const routerMidWare = routerMiddleware(history);
const composeEnhancers =
  process.env.NODE_ENV === 'development'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;

const store = createStore(
  combineReducers({ ...rootReducer, router: routerReducer }),
  composeEnhancers(applyMiddleware(authMidWare, routerMidWare, ReduxThunk))
);

export default store;
